export default __webpack_public_path__ + "static/media/December_02.a3a1ddbf.png";